import { Platform } from "./platform";
import { Popup } from "./popup";

export class AppDownloadRouter {
    constructor(options = {}) {
        this.come_back_on_pc_popup = null;
        this.setupComeBackToPcPopup(options.popupSelector, options.popupDismiss);
        this.bindClickToDownloadBtn(options.downloadBtn);
        this.bindClickToAppStoreBtn(options.appStoreBtn);
        this.bindClickToAmazonAppStoreBtn(options.amazonAppStoreBtn);
        this.bindClickToPlayStoreBtn(options.playStoreBtn);
        this.bindClickToPCorMacBtn(options.pcOrMacBtn);
    }

    static navigateToAppStore() {
        console.log('Navigate to App store');
        window.location.href = "https://itunes.apple.com/app/animal-jam-play-wild!/id1003820457";
    }

    static navigateToPlayStore() {
        console.log('Navigate to Play store');
        window.location.href = "https://play.google.com/store/apps/details?id=com.WildWorks.AnimalJamPlayWild" ;
    }

    static navigateToAmazonAppStore() {
        console.log('Navigate to Amazon app store')
        window.location.href = "https://www.amazon.com/WildWorks-Animal-Jam-Play-Wild/dp/B01N3JUZ8L";
    }

    static downloadForPC() {
        console.log('Download Playwild.exe');
    }

    static downloadForMac() {
        console.log('Download Playwild.dmg')
    }

    static platFormActions(platform) {
        return {
            'desktopMac': AppDownloadRouter.downloadForMac,
            'desktopPC': AppDownloadRouter.downloadForPC,
            'android': AppDownloadRouter.navigateToPlayStore,
            'kindle': AppDownloadRouter.navigateToAmazonAppStore,
            'ios': AppDownloadRouter.navigateToAppStore
        }[platform]
    }

    bindClickToDownloadBtn(target) {
        jQuery(document).on('click', target, (e) => {
            this.performDesktopAction(e)
        })
    }

    bindClickToAppStoreBtn(target) {
        jQuery(document).on('click', target, () => {
            AppDownloadRouter.navigateToAppStore();
        })
    }

    bindClickToAmazonAppStoreBtn(target) {
        jQuery(document).on('click', target, () => {
            AppDownloadRouter.navigateToAmazonAppStore();
        })
    }

    bindClickToPlayStoreBtn(target) {
        jQuery(document).on('click', target, () => {
            AppDownloadRouter.navigateToPlayStore();
        })
    }

    bindClickToPCorMacBtn(target) {
        jQuery(document).on('click', target, (e) => {
            this.performDesktopAction(e)
        })
    }

    performDesktopAction(event) {
        const target = event.target;
        const href = target.getAttribute('data-href');
        if(href === '') {
            this.showComeBackToPcPopup();
            event.preventDefault();
            event.stopPropagation();
        } else {
            window.open(href, '_blank');
        }
    }

    setupComeBackToPcPopup(popupSelector, popupDismiss) {
        this.come_back_on_pc_popup = Popup.setup({
            selector: popupSelector,
            dismiss: popupDismiss
        })
    }

    static triggerPlatFormAction() {
        let platform = Platform.getOS();
        let platformAction = AppDownloadRouter.platFormActions(platform);
        platformAction()
    }

    showComeBackToPcPopup() {
        this.come_back_on_pc_popup.Show();
    }

    static setup(options = {}) {
        new AppDownloadRouter(options)
    }
}